/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2018, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class DataSourcesUIAPI
 * @hideconstructor
 *
 * @classdesc implementation of the DataSourcesUIAPI interface.
 */
define([], () => {
	class DataSourcesUIAPI {

		/**
		 * @function DataSourcesUIAPI#getColumnSourceTree
		 * @description gets mui tree hierarchy of an item
		 * @public
		 * @async
		 *
		 * @param {String} sourceId
		 * @param {String} columnId
		 *
		 * @return {Object} React object with a hierarchy tree of an item
		 */
		getColumnSourceTree(/*sourceId, columnId*/) {}

		/**
		 * @function DataSourcesUIAPI#pickItems
		 * @description Used to pick disambiguated fields from the datasource
		 */
		pickItems() {}

		/**
		 * @function DataSourcesUIAPI#getPickTree
		 * @description used to pick fields from filtered mui tree
		 * @public
		 * @async
		 *
		 * @param {String} sourceId (e.g. '').
		 * @param {String} searchString (e.g. 'Revenue').
		 * @param {Requester~requestCallback} onSelectCallack Callback function that acts based on the selected fields on dashboard side.
		 * @param {String[]} [includeOptions=null] To filter the MUI tree based on the items in the array. (e.g. ['QueryItem', 'fact'])
		 * @param {PickTreeContext} [context] Context describing where the pick tree is being requested to render
		 *
		 * @return {Object} React object with mui tree fields that match filter
		 */
		getPickTree(/*sourceId, searchString, onSelectCallack, includeOptions*/) {}

	}

	return DataSourcesUIAPI;
});
